import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueWindowSize from 'vue-window-size'
import VueRouter from 'vue-router'

Vue.config.productionTip = false
Vue.use(VueWindowSize)
Vue.use(VueRouter)
const router = new VueRouter({ mode: 'history', base: new URL(window.APPLICATION.exposedUrl).pathname })
window.vIframeOptions = {
  router,
  reactiveParams: true,
}

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App),
}).$mount('#app')
